var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"search-filters-option"},[_c('label',{attrs:{"for":_vm.getInputId}},[_c('input',{ref:"checkbox",attrs:{"type":"checkbox","id":_vm.getInputId},domProps:{"checked":_vm.value},on:{"change":_vm.handleChange}}),_vm._v("\n        "+_vm._s(_vm.name)+" ("+_vm._s(_vm.count)+")\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }